import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import DropdownStyles from '@stories/Components/Inputs/Dropdown/Dropdown.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
import { BookEventFormStyles } from '../../BookEventForm.styles';
const Container = styled(BookEventFormStyles.FormBase) ``;
const Description = styled.div `
  ${paragraphSmall};
  margin: 0;
  margin-bottom: 32px;
`;
const DropdownWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;

  span {
    ${paragraphSmall};
    ${fonts.lato.bold};
    margin: 0;
  }

  ${DropdownStyles.Container} {
    max-width: 428px;
  }
`;
const AttendeesList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;

  &[data-has-value='true'] {
    padding-top: 25px;
  }
`;
const AttendeeQuantity = styled.input `
  width: 46px;
  aspect-ratio: 1 / 1;
  border: 0;
  font: inherit;
  border-radius: 10px;
  ${fonts.lato.bold};
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  appearance: textfield;
  -moz-appearance: textfield;
`;
const AttendeeInfo = styled(m.div).attrs(() => ({
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
    variants: {
        hidden: {
            x: -25,
            opacity: 0,
        },
        visible: {
            x: 0,
            opacity: 1,
        },
    },
})) `
  display: flex;
  gap: 18px;
  align-items: center;

  svg {
    width: 17px;
    cursor: pointer;
  }

  ${fonts.lato.bold};
`;
const SummaryList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
  user-select: none;
`;
const SummaryItem = styled.div `
  display: flex;
  align-items: center;
  gap: 12px ${fluid(14, 16)};

  > span {
    ${fonts.lato.medium};

    margin-right: ${fluid(32, 48)};
  }

  @media ${until(Device.Tablet)} {
    flex-wrap: wrap;
  }
`;
const SummaryQuantity = styled.div `
  ${fonts.lato.bold};
  font-size: 18px;
  padding: 14px 20px;
  text-align: center;
  background-color: ${brand.grey.grey97};
  border-radius: 10px;
`;
const SummaryPrice = styled.div `
  ${fonts.lato.medium};
  padding: 14px 20px;
  background-color: ${brand.primary.blue};
  color: ${brand.white};
  border-radius: 10px;
  white-space: nowrap;

  span[data-discounted='true'] {
    text-decoration: line-through;
  }
`;
export const StepOneStyles = {
    Container,
    Description,
    DropdownWrapper,
    AttendeesList,
    AttendeeInfo,
    AttendeeQuantity,
    SummaryList,
    SummaryItem,
    SummaryQuantity,
    SummaryPrice,
};
